import typedAction from "data/util/typedAction";
import PropTypes from "prop-types";
import EntityProxy from "data/util/EntityProxy";
import { recordIdType } from "data/util/typedefs";

const MapDialogActions = {
    SELECT_PLUGIN: typedAction("map-dialog/select-plugin", {
        key: PropTypes.string.isRequired,
    }),
    TOGGLE_DRAWER: "map-dialog/toggle-drawer",
    SELECT_SOURCE: typedAction("map-dialog/select-source", {
        source: PropTypes.instanceOf(EntityProxy).isRequired,
    }),
    SELECT_PAGE: "map-dialog/select-page",
    SET_MAGIC_ROOT_EXCLUSION: typedAction("map-dialog/set-magic-root-exclusion", {
        excluded: PropTypes.bool.isRequired,
    }),
    TOGGLE_EXCLUSION: typedAction("map-dialog/toggle-exclusion", {
        recordId: recordIdType.isRequired,
        columnKey: PropTypes.string.isRequired,
        itemKey: PropTypes.any, // undefined for field-level exclusions
    }),
    IMPORT: "map-dialog/import",
    CANCEL: "map-dialog/cancel",
};

export default MapDialogActions;



// WEBPACK FOOTER //
// ./app/data/MapDialogActions.js